import { fontSizeDropDownPlugin } from './plugin'

export const initFontSizeDropDownPlugin = () => {
  if (CKEDITOR.plugins.get('fontsizedropdown')) {
    return
  }

  CKEDITOR.plugins.add('fontsizedropdown', fontSizeDropDownPlugin)
}
